import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { OnlinetestModel } from 'projects/core/src/lib/models/onlinetest.model';
import { PartnerModel } from 'projects/core/src/lib/models/partner.model';

@Component({
  selector: 'app-partner-basedata',
  templateUrl: './partner-basedata.component.html',
  styleUrls: ['./partner-basedata.component.scss']
})
export class PartnerBasedataComponent implements OnInit {

  @Input() partner: PartnerModel = null;

  constructor(
    private router: Router,
    private ui: UiService,
    private auth: AuthStateService,
  ) { }

  ngOnInit(): void {
    this.ui.setFocus();
  }

  onOpen(onlinetest: OnlinetestModel): void {
    if (this.auth.hasRight('admin.onlinetest.show')) {
      this.router.navigate(['/partners', this.partner.id, 'onlinetests', onlinetest.id]);
    }
  }

}
